<app-authorized-guard
  [authorized]="authorized$ | async"
  message="You are not authorized to view this Organization."
>
  <app-loading-guard [loading]="loading$ | async">
    <div *ngIf="item$ | async as item">
      <div class="organization-details">
        <div class="organization-header">
          <span>{{ item.name }}</span>
          <button
            color="primary"
            *hasPrivilege="'organization/update'"
            mat-raised-button
            routerLink="/organization/edit"
          >
            Edit
          </button>
        </div>
        <dl class="details-list">
          <dt>Address</dt>
          <dd>{{ item.street_address }}</dd>
          <dt>Default homesick days</dt>
          <dd>{{ item.default_homesick_days }}</dd>
        </dl>
        <dl class="preference-list">
          <dt>Organization Preferences</dt>
          <dd>
            <mat-checkbox
              class="preference-checkbox kh-display-checkbox"
              [checked]="item.discover_locations"
              disabled
            >
              Automatically discover locations
            </mat-checkbox>
            <div class="checkbox-with-info">
              <mat-checkbox
                class="preference-checkbox kh-display-checkbox"
                [checked]="item.any_fixed_is_home"
                disabled
              >
                Treat all Vehicles, Trailers and Warehouses as home
              </mat-checkbox>
              <mat-icon
                class="info-icon"
                matTooltip="When unchecked, only home warehouses and the vehicles and trailers assigned to each as their home warehouse are treated as home."
                matTooltipPosition="after"
                aria-label="About treating vehicles, trailers, and warehouses as home"
              >
                info
              </mat-icon>
            </div>
          </dd>
        </dl>
      </div>
    </div>
  </app-loading-guard>
</app-authorized-guard>
